import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const SCSpinner = styled.div`
  display: inline-block;
  height: ${p => p.size};
  position: relative;
  width: ${p => p.size};

  & div {
    animation: ${spin} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${p =>
        p.color === 'white' ? p.theme.color.white : p.theme.color.blue}
      transparent transparent transparent;
    border-radius: 50%;
    border-style: double;
    border-width: calc(${p => p.size} * 0.156);
    box-sizing: border-box;
    display: block;
    height: calc(${p => p.size} * 0.795);
    margin: calc(${p => p.size} * 0.094);
    position: absolute;
    width: calc(${p => p.size} * 0.795);
  }

  & div:nth-child(1) {
    animation-delay: -0.45s;
  }

  & div:nth-child(2) {
    animation-delay: -0.3s;
  }

  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export default SCSpinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/styles.js